export const getMaxLengthMessage = (maxLength, value) => {
  var _value$length;
  const currentLength = Math.min(maxLength, (_value$length = value == null ? void 0 : value.length) != null ? _value$length : 0);
  return `${currentLength}/${maxLength}`;
};